<template>
  <div id="taskline">
    <div class="stage2">
      <div class="flex-box relativeItem" v-for="(n, index) in own_list" :key="index">
        <img :src="n.picSrc_tipic" class="sign absoluteItem" v-if="n.picSrc_tipic != ''" />
        <img class="img" :src="n.picSrc" />
        <div class="line">
          <p class="p1">{{ n.title }}</p>
          <p class="p2" v-if="type != 'public'">
            <span :style="{width:(n.complete_val*1/(n.task_val*1)*100) + '%'}"></span>
          </p>

          <div class="p3 flex-box" v-else>
            <p class="flex-box" v-for="(x, zx) in n.rewardlist" :key="zx">
              <img class="imgBlcok" :src="x.img" />
              {{ x.title }}
            </p>
          </div>
        </div>
        <div
          class="absoluteItem centerY ing button"
          v-if="n.finished == '0'"
          @click="take_task(index)"
        >去完成</div>
        <div
          class="absoluteItem centerY able button"
          v-else-if="n.finished == '1' && n.isreceive == 0 && type == 'public'"
          @click="get_award(index)"
        >可领取</div>
        <div
          class="absoluteItem centerY get button"
          v-else-if="n.finished == '1' && n.isreceive == 1 && type == 'public'"
        >已领取</div>

        <img
          class="finished-img absoluteItem centerY"
          src="../../assets/task/task(13).png"
          v-else-if="n.finished == 1 && type == 'basepay'"
        />
      </div>
    </div>
  </div>
</template>





















<script>
export default {
  name: "taskline",
  props: ["list", "type"],
  components: {},
  data() {
    return {
      own_list:this.list
    };
  },
  methods: {
    /**通知app打开相关页面 */
    take_task(index) {
      let data = {
        ios: this.list[index].jump.ios,
        android: this.list[index].jump.android
      };
      this.$appAc.actionAsPhp(data);
    },

    /**领取奖励 */
    get_award(index) {
      let _this = this;
      let data = {
        taskid:this.list[index].id
      };
      this.$jsonp(this.$apis("task_get_award"), data, res => {
        if (res.data.data.data.re.status === 1) {
          //领取成功
          _this.own_list[index].isreceive = 1;
        }
      });
    }
  },
  mounted: function() {}
};
</script>



















<style scoped>
/**第二阶段 */
.stage2 {
  margin-bottom: 7px;
}
.stage2 > div {
  overflow: hidden;
  padding: 9px;
  /* align-items: center; */
  background: rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  margin-bottom: 5px;
}
.stage2 .img {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  margin-right: 8px;
}
.stage2 .line {
  width: 80%;
}
.stage2 .p1 {
  font-size: 11px;
  color: white;
}
.stage2 .p2 {
  width: 67%;
  height: 4px;
  margin-top: 15px;
  border-radius: 3rem;
  background: rgba(0, 0, 0, 0.1);
}
.stage2 .p2 span {
  display: block;
  height: 100%;
  transition: all 0.6s;
  border-radius: 3rem;
  max-width: 100%;
  background: linear-gradient(to right, #ffe544, #ffaa34);
}
.stage2 .p3 {
  align-items: center;
  font-size: 8px;
  color: #ffe756;
  margin-top: 4px;
}
.stage2 .p3 img {
  width: 16px;
  height: 16px;
  margin-right: 2px;
}
.stage2 .p3 p {
  margin-right: 8px;
  font-size: 8px;
  align-items: center;
}
.stage2 .button,
.stage2 button {
  background: none;
  border-radius: 25px;
  padding: 4px 15px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  right: 16px;
}
.stage2 .sign {
  width: 50px;
  height: 50px;
  top: 0;
  left: 0;
}
.stage2 .ing {
  border: 1px solid rgba(255, 255, 255, 0.6);
}
.stage2 .get {
  border: 1px solid rgba(255, 255, 255, 0);
}
.stage2 .able {
  color: #bb3215;
  border: 1px solid #ffd856;
  background: #ffd856;
}
.stage2 .finished-img {
  width: 45px;
  right: 16px;
}
</style>
